export const COLORS = ['danger', 'warning', 'success', 'primary', 'neutral', 'moss'];
export const VARIANTS = ['filled', 'light', 'lighter', 'outlined'];
export const SIZES = ['small', 'large'];

export const getColorShade = (color) => (color === 'neutral' ? 700 : 500);

export const getBackgroundClass = (color, variant) => {
  const shade = getColorShade(color);
  switch (variant) {
    case 'filled':
      return `bg-${color}-${shade}`;
    case 'light':
      return `bg-${color}-100`;
    case 'lighter':
      return `bg-${color}-50`;
    case 'outlined':
      return 'bg-white';
    default:
      return `bg-${color}-50`;
  }
};

export const getBorderClass = (color, variant) => {
  const borderColor = variant === 'lighter' ? color : 'neutral';
  if (variant === 'lighter' || variant === 'outlined') {
    return `border border-solid border-${borderColor}-200`;
  }
};

export const getShade = (variant) => {
  if (variant === 'outlined') return 'shadow-[0px_0px_16px_0px_rgba(55,65,69,0.08)]';
};

export const getIconColor = (color, variant) => {
  if (variant === 'filled') return 'white';
  return color;
};

export const getIconShade = (color, variant) => {
  if (variant === 'filled') return undefined;
  return getColorShade(color);
};

export const getTextClass = (color, variant, isTitle) => {
  if (variant === 'filled') return 'text-white';
  const shade = isTitle ? 900 : 800;
  return `text-neutral-${shade}`;
};

export const getSizeClasses = (size = 'small') => {
  switch (size) {
    case 'small':
      return {
        padding: 'px-3 py-2',
        iconSize: 20,
        lineHeight: 'leading-[22px]',
        textFontSize: 'text-[14px]',
        fontWeight: 'font-400',
        height: 'min-h-[36px]'
      };
    case 'large':
      return {
        padding: 'p-3',
        iconSize: 20,
        lineHeight: 'leading-[22px]',
        textFontSize: 'text-[14px]',
        fontWeight: 'font-500'
      };
  }
};

export const getCtaButtonColor = (color, variant) => {
  if (variant === 'filled') {
    return color === 'neutral' ? 'neutral' : color;
  }
  return color;
};

export const getCtaButtonShade = (color, variant) => {
  if (variant === 'filled') {
    return color === 'neutral' ? 600 : 400;
  }
  return 500;
};
